import HeaderComponent from '@/components/HeaderRefactored/HeaderRefactored';
import { ScheduledEmail } from '@/resources/assets/images';
import { useEffect, useState } from 'react';
import ScheduledEmailsBody from './ScheduledEmailsBody';

import ScheduledEmailsFilter from './ScheduledEmailsFilter';
import './ScheduledEmailsRedesign.scss';

const ScheduledEmailsRedesign = (): JSX.Element => {
	const [selectedEmails, setSelectedEmails] = useState<string[]>([]);

	return (
		<div className="scheduled-emails-div-redesign">
			<HeaderComponent
				icon={<ScheduledEmail className="scheduled-email-icon" />}
				name="Scheduled Emails"
				description="Manage pending communication by being able to cancel scheduled emails."
			/>

			<ScheduledEmailsFilter
				selectedEmails={selectedEmails}
				setSelectedEmails={setSelectedEmails}
			/>

			<ScheduledEmailsBody
				selectedEmails={selectedEmails}
				setSelectedEmails={setSelectedEmails}
			/>
		</div>
	);
};

export default ScheduledEmailsRedesign;
